import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Text from 'components/common/Text'
import Icon, { ICON_FLAME } from 'components/common/Icon'
import Modal from 'components/modal/Modal'

const EmbeddedModal = props => {
  const { actions, children, ...rest } = props

  return (
    <Modal
      {...rest}
      embedded
      cancellable={false}
      actions={actions}
    >
      <Div
        paddingTop={16}
        paddingLeft={24}
        paddingRight={24}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Icon width={60} height={60} path={ICON_FLAME} />
        <Div width="100%" paddingTop={20} paddingBottom={14}>
          <Text size={14} color="black">{children}</Text>
        </Div>
      </Div>
    </Modal>
  )
}

EmbeddedModal.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.node
}

EmbeddedModal.defaultProps = {
  actions: []
}

export default EmbeddedModal



// WEBPACK FOOTER //
// ./src/components/modal/EmbeddedModal.js